import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { BillingProcess } from 'src/app/models/billing-process';
import { BillingProcessService } from 'src/app/services/billing-process.service';
import { MessageUtil } from 'src/app/utils/message.util';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-billing-process-wizard',
  templateUrl: './billing-process-wizard.component.html',
  styleUrls: ['./billing-process-wizard.component.scss'],
})
export class BillingProcessWizardComponent implements OnInit {
  process: BillingProcess | null = null;
  activeStepIndex = 0;
  loading = false;

  steps: MenuItem[] = [
    { label: 'Geração de Pedidos' },
    { label: 'Pedidos Existentes' },
    { label: 'Resumo de Faturamento' },
    { label: 'Dados de Faturamento' },
    { label: 'Confirmação' },
    { label: 'Execução' },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private billingProcessService: BillingProcessService,
    private spinner: NgxSpinnerService,
    private messageService: MessageUtil,
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (!idParam) {
      this.voltar();
      return;
    }
    this.loadProcess(Number(idParam));
  }

  private loadProcess(id: number): void {
    this.loading = true;
    this.spinner.show();
    this.billingProcessService.findById(id).subscribe({
      next: (process) => {
        this.spinner.hide();
        this.loading = false;
        this.process = process;
        this.activeStepIndex = Math.min(Math.max((process.currentStep ?? 1) - 1, 0), 5);
      },
      error: (err) => {
        this.spinner.hide();
        this.loading = false;
        this.messageService.generateMessage(
          'error',
          'SUMMARY.ERROR',
          err?.error?.message ?? 'Erro ao carregar processo.',
        );
        this.voltar();
      },
    });
  }

  voltar(): void {
    this.router.navigate(['/app/billing/billing-process']);
  }

  confirmarSaida(): void {
    Swal.fire({
      title: 'Sair do processo?',
      text: 'O progresso fica salvo como rascunho.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sair',
      cancelButtonText: 'Continuar no processo',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.voltar();
      }
    });
  }

  goToStep(index: number): void {
    this.activeStepIndex = index;
  }

  proximo(): void {
    if (this.activeStepIndex < this.steps.length - 1) {
      this.activeStepIndex++;
    }
  }

  anterior(): void {
    if (this.activeStepIndex > 0) {
      this.activeStepIndex--;
    }
  }
}
